<template>
  <b-row>
    <b-col cols="12">
      <b-card>
        <title-text />
        <content-text />
        <ordering />
      </b-card>
    </b-col>
    <b-col
      cols="12"
      md="8"
    >
      <image-card />
    </b-col>
    <b-col
      cols="12"
      md="4"
    >
      <file-card />
    </b-col>
    <b-col cols="12">
      <b-button
        variant="primary"
        :disabled="itemData.submitStatus"
        @click="submitForm"
      >
        Kaydet
      </b-button>
    </b-col>
  </b-row>
</template>

<script>
import {
  BCard, BCol, BRow, BButton,
} from 'bootstrap-vue'

import TitleText from '@/views/Admin/Certificates/elements/Title.vue'
import ContentText from '@/views/Admin/Certificates/elements/Content.vue'
import Ordering from '@/views/Admin/Certificates/elements/Ordering.vue'
import ImageCard from '@/views/Admin/Certificates/elements/Image.vue'
import FileCard from '@/views/Admin/Certificates/elements/FileCard.vue'

export default {
  name: 'ItemForm',
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    TitleText,
    ContentText,
    Ordering,
    ImageCard,
    FileCard,
  },
  props: {
    submitForm: {
      type: Function,
      required: true,
    },
  },
  computed: {
    itemData() {
      return this.$store.getters['certificates/dataItem']
    },
  },
}
</script>
